import { createClient } from '@supabase/supabase-js'
import type { Database } from '@/types/database'

const url = import.meta.env.VITE_SUPABASE_URL
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!url || !anonKey) {
  throw new Error(
    'Missing VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY. Copy .env.example to .env.local.',
  )
}

export const supabase = createClient<Database>(url, anonKey, {
  auth: {
    // The PWA can be reopened days later; keep the session alive across launches.
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
    storageKey: 'bella.auth',
  },
  realtime: {
    // Enough headroom for typing indicators without letting a chatty client
    // flood the socket.
    params: { eventsPerSecond: 20 },
  },
  global: {
    headers: { 'x-client-info': 'bella-pwa' },
  },
})

export type SupabaseClient = typeof supabase
